import { ValidationRefData, ValidatedGDORow } from './GDOBulkUploadTypes';
import { fetchBulkUploadLookups } from '../../service/service';

// ── Static reference constants (not from DB) ────────────────────────────────

export const VALID_TIMEZONES: string[] = [
  'CST', 'EST', 'PST', 'MST', 'UTC', 'GMT', 'CET', 'EET', 'IST', 'JST',
  'AEST', 'AEDT', 'UTC-5', 'UTC-6', 'UTC+1', 'UTC+2',
  'America/Chicago', 'America/New_York', 'America/Denver', 'America/Los_Angeles',
  'America/Mexico_City', 'America/Sao_Paulo', 'America/Argentina/Buenos_Aires',
  'Europe/London', 'Europe/Paris', 'Europe/Berlin', 'Europe/Madrid', 'Europe/Rome', 'Europe/Warsaw',
  'Asia/Tokyo', 'Asia/Shanghai', 'Asia/Singapore', 'Asia/Dubai',
  'Australia/Sydney', 'Australia/Melbourne',
];

// ── Initial ref data factory ────────────────────────────────────────────────

/**
 * Creates a fresh ValidationRefData with empty DB fields and populated static constants.
 * DB fields (sectors, markets, reports, existingGDONames) are populated later by fetchLookupData / fetchExistingGDONames.
 */
export function createEmptyRefData(): ValidationRefData {
  return {
    sectors: [],
    markets: [],
    reports: [],
    timezones: VALID_TIMEZONES,
    existingGDONames: new Set(),
    platformSchedulerMap: {},
  };
}

// ── API fetch functions ─────────────────────────────────────────────────────

/**
 * Fetch lookup data (sectors, markets, reports) from the backend API.
 * Returns only the DB-sourced fields.
 */
export async function fetchLookupData(): Promise<{
  sectors: string[];
  markets: string[];
  reports: string[];
  platformSchedulerMap: Record<string, string[]>;
}> {
  try {
    const response = await fetchBulkUploadLookups();
    if (response?.success && response?.data) {
      return {
        sectors: response.data.sectors || [],
        markets: response.data.markets || [],
        reports: response.data.reports || [],
        platformSchedulerMap: response.data.platformSchedulerMap || {},
      };
    }
  } catch (err) {
    console.warn('Failed to fetch lookup data from API:', err);
  }
  return { sectors: [], markets: [], reports: [], platformSchedulerMap: {} };
}

/**
 * Fetch existing GDO names from the backend to prevent duplicates.
 * Currently returns an empty set — will be wired to an API endpoint later.
 */
export async function fetchExistingGDONames(): Promise<Set<string>> {
  // TODO: Replace with actual API call when backend endpoint is available
  return new Set();
}

export async function validateRowsAPI(
  rows: ValidatedGDORow[]
): Promise<{
  validRows: ValidatedGDORow[];
  serverErrors: { rowId: number; reason: string }[];
}> {
  await new Promise((r) => setTimeout(r, 500));
  return { validRows: rows, serverErrors: [] };
}

export async function commitGDOsAPI(
  rows: ValidatedGDORow[]
): Promise<{
  successCount: number;
  failures: { rowId: number; reason: string }[];
}> {
  await new Promise((r) => setTimeout(r, 1000));
  return { successCount: rows.length, failures: [] };
}
